import { Box } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom";
import { FC } from "react";
import React from "react";
import { signOut } from "aws-amplify/auth";
import logoutBackend from "../../shared/api/logoutBackend";
import { setSessionItem, HEADER_DISABLED_KEY } from "../storageCheck/storageCheck";
import { HeaderLabel, ReturnButton } from "./error.styles";

const Error: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { title, message, isLogin = true } = location.state
    const logoutAction = async () => {
        // ログアウト(サーバーサイド)
        await logoutBackend();
        // サインアウト(Authenticator)
        signOut();
        // セッションストレージのクリア
        sessionStorage.clear();
        document.title = "TSR-Eyes";
        window.history.replaceState("", "", "/");
    }
    const refreshPage = () => {
        navigate("/");
        window.location.reload();
    };

    React.useEffect(() => {
        // ブラウザのタブに表示される値の更新
        document.title = title;

        setSessionItem(HEADER_DISABLED_KEY, "true")
        return () => setSessionItem(HEADER_DISABLED_KEY, "false")
    }, []);


    return (
        <>
            <HeaderLabel>
                {title}
            </HeaderLabel>
            <Box sx={{ textAlign: 'center', marginTop: "12rem", marginBottom: "15rem" }}>
                <div>
                    {message}
                </div>
                {isLogin ?
                    <ReturnButton variant="contained" color="secondary" style={{ marginTop: '25px' }} onClick={() => logoutAction()}><img src={`${process.env.PUBLIC_URL}/Icons/returnIcon.svg`} alt="returnIcon" width="13px" />&nbsp;ログイン画面に戻る</ReturnButton>
                    :
                    <ReturnButton variant="contained" color="secondary" style={{ marginTop: '25px' }} onClick={() => refreshPage()}><img src={`${process.env.PUBLIC_URL}/Icons/returnIcon.svg`} alt="returnIcon" width="13px" />&nbsp;認証画面へ戻る</ReturnButton>
                }
            </Box>
        </>
    );
}
export default Error;
